export default {
  cancelOrderMap: {
    0: "Я не хочу этого.",
    1: "Неуместный продукт",
    2: "Дублирующий заказ",
    3: "Не удалось получить",
    4: "Другие причины",
  },
  "获取验证码": "Получить код",
  "请输入验证码": "Пожалуйста, введите код",
  "验证码错误": "Код неверен",
  "验证码": "Код",
  "发送": "Отправить",
  "已发送，请注意查收":
    "Отправлено, пожалуйста, проверьте почту",
  "请选择": "Пожалуйста, выберите",
  "仅能绑定一个收款地址!": "Можно привязать только один адрес для получения платежей!",
  "绑定成功": "Привязка успешна",
  "提款地址绑定": "Привязка адреса снятия наличных",
  "电商批发商场": "Оптовый рынок электронной коммерции",
  "请输入完整的支付密码!" : "Пожалуйста, введите полный пароль для оплаты!",
  "用户未发表评论": "Пользователь не прокомментировал",
  "订单": "Заказ",
  "下单成功，等待付款": "Заказ успешно оформлен, ждем оплаты",
  "下单成功，付款成功": "Заказ успешно размещен, оплата прошла успешно",
  "已发货，正在运输中": "Отгружено, в транспорте",
  "订单已取消，原因:手动发起取消订单": "Заказ отменен. Причина: Отменить заказ вручную.",
  "订单已取消，原因:超时自动取消订单": "Заказ отменен. Причина: Заказ будет автоматически отменен по истечении времени ожидания.",
  "商家已确认，已进入备货状态": "Продавец был подтвержден и вошел в состояние склада.",
  "系统发货成功": "Доставка системы прошла успешно",
  "订单已签收": "Заявка принята",
  "发起退款申请": "Инициировать запрос на возврат",
  "退款成功": "Возврат выполнен",
  "退款失败": "Не удалось вернуть деньги",
  "订单退款成功": "Возврат заказа выполнен",
  "订单退款失败": "Не удалось вернуть заказ",
  "系统默认好评": "Система по умолчанию дает положительные отзывы",
  "请输入关键字搜索": "Пожалуйста, введите ключевое слово для поиска",
  "猜你喜欢": "Думаю, тебе это нравится",
  "订单已完成": "Заказ выполнен",
  "热销推荐": "Горячие рекомендации по продажам",
  "头像选择": "Выбор аватара",
  "修改头像": "Изменить свой аватар",
  subOrder: "Подтвердить заказ",

  "mailboxCheck": "Пожалуйста, заполните правильный адрес электронной почты",
  "switchLang": "Пожалуйста, переключитесь на другой язык для просмотра",
  "myCart": "Моя корзина",
  "notQua": "Квалификационные условия не соблюдены.",
  "noSmaller": "Применяемая сумма не может быть меньше",
  "nomax": "Максимальная сумма заявки не может превышать",
  "evaluationUploading": "У вас все еще загружаются фотографии. Пожалуйста, повторите попытку позже",
  "evaluateInput": "Обзор с картинками",
  "moneyOrderStatus": "Статус заказа",
  "coinBlock": "Валютное соглашение",
  "dealing": "В процессе",
  "dealSuccess": "Успешный",
  "dealFail": "Неудача",
  "payCertificate": "Платежный сертификат",
  "handleFee": "Плата за обслуживание",
  "highOpinion": "Хорошие отзывы",
  "mediumOpinion": "Средний обзор",
  "lowOpinion": "Плохие отзывы",
  "hasImage": "С картинками",
  "rechargeMethod": "Режим перезарядки",
  "scanAndDown": "Сканировать QR-код Скачать приложение",
  "receivedAddress": "Адрес получения",
  "ActualLedger": "Фактическое получение",
  "view": "Вид",
  "withdrawNum": "Количество снятия наличных",
  "rechargeNum": "Количество пополнения",
  "date": "Дата",
  "walletHistory": "История кошелька",
  "accountBalance": "Баланс",
  "accountReview": "Обзор аккаунта",
  "rated": "Рассмотрено",
  "receiver": "Получатель",
  "orderStatus": "Положение дел",
  "orderTime": "Время",
  "tax": "Налогообложение",
  "discount": "Скидка",
  "productInfo": "Информация о продукте",
  "paramError": "Ошибка параметра",
  "orderInfo": "Запросить информацию",
  "rebuy": "еще один заказ",
  "pleaseCorrectAddress": "Пожалуйста, введите правильный адрес для снятия наличных",
  "pleaseInputCorrectNumber": "Пожалуйста, введите число больше 0",
  "vcodePass": "Проверка прошла!",
  "vcodeFail": "Ошибка авторизации. Пожалуйста, повторите",
  "uploading": "Загрузка...",
  "uploadSuccess": "Загружено успешно",
  "uploadError": "Загрузка не удалась. Пожалуйста, попробуйте еще раз",
  "registerSuccess": "Регистрация прошла успешно",
  "pleaseSetMobileNumber": "Пожалуйста, укажите номер телефона",
  "unSelectedProduct": "Вы не выбрали товар",
  "loginSuccess": "Вход выполнен успешно",
  "pleaseSetAreaCode": "Введите название страны и код города для поиска",
  "login": "Авторизоваться",
  "register": "Постановка на учет",
  "logout": "Выход",
  "noData": "Данные не найдены",
  "search": "Поиск",
  "historySearch": "Исторический поиск",
  "empty": "Пустой",
  "home": "Домашняя страница",
  "favorableRate": "Рейтинг хороших отзывов",
  "classification": "Категория",
  "searchTips": "Исходный поиск/продукт/поставщик/заказ",
  "dailyNewArrival": "Список ежедневных новых продуктов",
  "more": "Более",
  "recommend": "Рекомендация",
  "recommendedProducts": "Рекомендуемые продукты",
  "recommendedStore": "Рекомендуемые магазины",
  "buyNow": "Купить сейчас",
  "addCart": "Добавить в корзину",
  "complex": "Интегрированный",
  "price": "Цена",
  "retailPrice": "Розничная цена",
  "originPrice": "Изначальная цена",
  "service": "Обслуживание клиентов",
  "collect": "Избранное",
  "sold": "Объем продаж",
  "pageviews": "Количество просмотров",
  "quantity": "Количество",
  "freight": "Груз",
  "shipping": "Перевозки",
  "ship": "Лодка",
  "buyTips": "Отправка в течение 24 часов после оформления заказа. Следующие заказы находятся на логистическом контроле и могут быть отправлены с опозданием. Пожалуйста, обратите внимание на информацию о логистике или свяжитесь со службой поддержки клиентов.",
  "totalPrice": "Итоговая цена",
  "addCartMessage": "Успешно добавлено в корзину",
  "addCartMessageFaild": "Товар уже есть в корзине.",
  "myAccount": "Мой qсчет",
  "buyHistory": "Записи о покупках",
  "wishlist": "Любимые продукты",
  "trackOrder": "Заказ",
  "account": "Счет:",
  "sellerZone": "Торговая зона",
  "beSeller": "Стать торговцем",
  "sellerPanelLogin": "Вход для продавца",
  "footTip": "© Copyright МетаШоп ООО 2024",
  "footTips": "{name} Limited уполномочена и регулируется Управлением финансового надзора в качестве кредитного брокера (713206) и работает исключительно с кредитором Home Retail Group CardServices Limited как {name} Financial Services. Финансовые услуги {name} уполномочены и регулируются Управлением финансового надзора для предоставления кредита (716148). Home Retail GroupCard Services Limited зарегистрирована в Соединенном Королевстве (04007072) по адресу Avebury, 489-499 Avebury Boulevard, Milton Keynes, United Kingdom. МК9 2НЗ.",
  "item": "Статья",
  "checkout": "Разместить заказ",
  "productDescription": "Описание продукта",
  "userEvaluation": "Отзывы Пользователей",
  "AllProducts": "Все продукты",
  "followers": "Следовать",
  "sales": "Объем продаж",
  "visitStore": "Посетите магазин",
  "authentic": "100% подлинный",
  "dayReturns7": "возврат 7 дней",
  "shippingDiscounts": "Скидка на фрахт",
  "safePayment": "Безопасная оплата",
  "followed": "Подписано",
  "dashboard": "Приборная доска",
  "myOrder": "Мой заказ",
  "setUp": "Настраивать",
  "successTips": "Успешный",
  "copySuccess": "Репликация выполнена успешно",
  "balance": "Баланс (USDT)",
  "sort": "Тип",
  "commodity": "Продукт",
  "browse": "Объем продаж",
  "recharge": "Перезарядка",
  "commodityCollection": "Коллекция продуктов",
  "withdraw": "Выдача наличных",
  "defaultAddress": "Адрес по умолчанию",
  "addNewAddress": "Добавить новый адрес",
  "withdrawRecord": "Запись о снятии наличных",
  "serialNumber": "№ заказа.",
  "time": "Время",
  "amount": "Количество",
  "processing": "В процессе",
  "fail": "Неудача",
  "blockchainNetwork": "Блокчейн сеть",
  "records": "Записывать",
  "withdrawAddress": "Адрес для снятия наличных",
  "withdrawInputTips": "Пожалуйста, введите адрес для вывода",
  "copy": "Репликация",
  "enterTips": "Пожалуйста входите",
  "actualAccount": "Фактический счет",
  "handlingFee": "Плата за обслуживание",
  "confirm": "Подтвердить получение",
  "previous": "Предыдущий шаг",
  "pleaseEnterAddress": "Пожалуйста, введите адрес",
  "pleaseEnterQuantity": "Пожалуйста, введите количество",
  "withdrawSuccess": "Заказы отправлены успешно",
  "saveQr": "Сохранить QR-код",
  "pleaseEnterAmount": "Пожалуйста, введите сумму пополнения",
  "expectedArrival": "Ожидаемое прибытие",
  "currentRate": "Текущий обменный курс",
  "uploadTips": "Подтверждение платежа (загрузить снимок экрана с деталями платежа)",
  "clickUpload": "Нажмите, чтобы загрузить",
  "uploadPhoto": "Пожалуйста, загрузите фотографии",
  "rechargeSuccessful": "Пополнение успешно",
  "rechargeTips": "Подсказка о пополнении: «Пожалуйста, введите фактическую сумму перевода правдиво. В противном случае система может не пройти одобрение и повлиять на ход пополнения.",
  "rechargeRecord": "Запись пополнения",
  "all": "Все",
  "pending": "Быть оплаченным",
  "cancelled": "Отменено",
  "delivered": "Для отправки",
  "confirmed": "Подтвержденный",
  "receipt": "быть полученным",
  "harvested": "Полученный",
  "comment": "Для рассмотрения",
  "refund": "Возврат/после продажи",
  "cancelOrder": "Отменить заказ",
  "cancelReason": "Причина отмены",
  "cancelOrderTitle": "Пожалуйста, выберите причину отмены заказа",
  "returnOrderTitle": "Пожалуйста, выберите причину возврата",
  "refundInstructions": "Инструкции по возврату",
  "returnDetailTips": "Пожалуйста, оставьте отзыв о товаре",
  "cancel": "Отменить заказ",
  "cancelOrder1": "Товар не получен",
  "cancelOrder2": "Не нравится, не хочу",
  "cancelOrder3": "Продавец отправил не тот товар",
  "cancelOrder4": "Поддельный бренд",
  "cancelOrder5": "Меньше отгрузки, пропущенная отгрузка",
  "cancelOrder6": "Товар получен поврежденным",
  "cancelOrder7": "Есть проблема с качеством",
  "cancelOrder8": "Обсудить возврат с продавцом",
  "cancelOrder9": "Другие причины",
  "cancelOrderSuccess": "Заказ успешно отменен",
  "returnOrderSuccess": "Отправить успешно",
  "orderName": "Имя",
  "orderEmail": "Электронная почта",
  "orderAddress": "Адрес",
  "orderNation": "Страна",
  "orderState": "Положение дел",
  "orderCity": "Город",
  "orderPostCode": "Почтовый индекс",
  "orderAmount": "Количество",
  "orderPrefix": "Общий заказ",
  "orderFee": "Налоги",
  "orderSpecification": "Спецификация",
  "orderCommodity": "Продукт",
  "orderQuantity": "Количество",
  "orderUnitprice": "Цена за единицу товара",
  "orderFreight": "Груз",
  "orderTax": "налог",
  "orderTotal": "Общий",
  "PaymentOrder": "Платежное поручение",
  "Evaluate": "Обзор",
  "CancelOrder": "Отменить заказ",
  "RemindShip": "Напоминание об отправке",
  "Refund": "Возвращать деньги",
  "Submitareview": "Отправить отзывы",
  "Information": "Информация",
  "wrongPassword": "Ошибка пароля более 3 раз. Повторите попытку завтра.",
  "Operate": "Операция",
  "Item": "Предметы)",
  "From": "От",
  "hint": "Советы",
  "CheckDetails": "Посмотреть детали",
  "Payment": "Оплата",
  "Cancel": "Отмена",
  "refundSuccessfully": "Возврат выполнен",
  "pendingPayment": "Быть оплаченным",
  "pay": "Оплата",
  "LoginPassword": "Логин Пароль",
  "sure": "Конечно",
  "shippingAddress": "Адрес получения",
  "pleaseAddShippingAddress": "Пожалуйста, сначала добавьте адрес доставки",
  "transactionPassword": "Пароль транзакции",
  "markDefaultAddress": "Отметить как адрес доставки по умолчанию",
  "edit": "Отредактировано",
  "delete": "Удалить",
  "Opt": "Выбирать",
  "piece": "шт",
  "orderDetails": "Информация для заказа",
  "shopCollection": "Добавить магазин в избранное",
  "addAddress": "Добавить новый адрес",
  "signUp": "Постановка на учет",
  "loginTips": "У вас уже есть аккаунт?",
  "loginIn": "Авторизоваться",
  "mobile": "Номер телефона",
  '购物车还没有商品': "В корзине еще нет товаров",
  '去购物': "Иди за покупками",
  "modifyAddress": "Изменить адрес",
  "desc": "Сделать адресом по умолчанию",
  "keep": "Поддерживать",
  "onlineService": "Онлайн-сервисы",
  "send": "Отправлять",
  "EsShop": "Интернет-магазин",
  "desc3": "Введите пароль транзакции",
  "desc4": "Введите пароль транзакции",
  "desc6": "Введите пароль транзакции еще раз",
  "setUpPayPaw": "Установить пароль транзакции",
  "setSuccess": "Установка прошла успешно",
  "confirmPayPaw": "Подтвердите пароль транзакции",
  "paymentSuccessful": "Платеж прошел успешно",
  "paymentPending": "Ожидание платежа",
  "paymentPendingDesc": "Ваш платеж обрабатывается. Пожалуйста, проверьте статус заказа позже",
  "desc5": "Неверный адрес доставки? Контакт",
  "customeService": "Онлайн обслуживание клиентов",
  "BackHome": "Вернуться на главную страницу",
  "Checkorder": "Посмотреть заказ",
  "ForgotPassword": "Забыть пароль?",
  "signIn": "Авторизоваться",
  "noAccount": "Нет номера счета?",
  "pleaseEnterAccount": "Пожалуйста, введите номер счета",
  "pleaseEnterPassword": "Пожалуйста введите пароль",
  "password": "Пароль",
  "mobilePhone": "Номер телефона",
  "pleaseEnterPhoneNumer": "Пожалуйста, укажите номер телефона",
  "setPassword": "Установка пароля",
  "noDataFound": "Данные не найдены",
  "searchCountry": "Введите название страны и код города для поиска",
  "pleaseEnterEmail": "Пожалуйста, установите почтовый ящик",
  "invitationCode": "Код приглашения",
  "plaeseEnterInvitaionCode": "Пожалуйста, установите код приглашения",
  "pleaseSetLoginPassword": "Пожалуйста, установите пароль для входа",
  "selectDeliveryAddress": "Выберите адрес доставки",
  "totalOf": "Общий",
  "items": "Элемент",
  "orderSummary": "Итог заказа",
  "paymentMethod": "Способ оплаты",
  "Balance": "Баланс",
  "payPal": "PayPal",
  "notOpen": "Этот способ оплаты еще не доступен для вашего региона",
  "mastercard": "Мастеркард",
  "additional": "Дополнительный",
  "handlingfee": "Требуется плата за обслуживание",
  "goodsNumber": "Количество продуктов",
  "deliveryFee": "Груз",
  "totalNum": "Общий",
  "new": "Новый",
  "oldPassword": "Старый пароль",
  "pleaseEnterOldPassword": "Пожалуйста, введите старый пароль",
  "newPassword": "Новый пароль",
  "plaseeEnterNewPassword": "Пожалуйста, введите новый пароль",
  "confirmPassword": "Подтвердите пароль",
  "plaseeENterConfirmPassword": "Пожалуйста, введите пароль для подтверждения",
  "twoPawword": "Два пароля не совпадают",
  "rechargeAddress": "Адрес пополнения",
  "plaseEnterRechargeAddress": "Пожалуйста, введите адрес пополнения",
  "userCenter": "Персональный центр",
  "merchantSettled": "Вход продавца",
  "upNew": "Новый продукт в списке",
  "balanceNot": "Баланса не хватает. Пожалуйста, перезарядите.",
  "NoProductSelected": "Товар еще не выбран",
  "ShippingAddressNotSet": "Адрес доставки не указан",
  "consigneeName": "Имя получателя",
  "email": "Электронная почта:",
  "areaCode": "Международный код города",
  "phoneNumber": "Номер телефона",
  "nation": "Страна",
  "state": "Провинция/Штат/Штат",
  "city": "Город",
  "postCode": "Почтовый индекс",
  "address": "Подробный адрес",
  "addAddressOrModifyAddress": "Добавить новый адрес/Изменить адрес",
  "setAsTheDefaultAddress": "Сделать адресом по умолчанию",
  "proceed": "Продолжать",
  "btnSure": "Подтверждать",
  "pleaseInput": "Пожалуйста входите",
  "allProduct": "Все продукты",
  "myCommodityCollection": "Любимые продукты",
  "myFollowedShops": "Следите за магазином",
  "mySold": "Продал",
  "myPageviews": "Количество просмотров",
  "myPraiseRate": "Рейтинг хороших отзывов",
  "myUnfollow": "Отписаться",
  "inputNum": "Числа",
  "inpuEmailErro": "Пожалуйста, введите правильный адрес электронной почты",
  "goodsShip": "Отгрузка",
  "goodsShipTips": "Товары будут отправлены в течение 24 часов после размещения заказа. Если для следующего заказа существует контроль логистики, заказ может быть задержан. Пожалуйста, обратите внимание на информацию о логистике заказа или свяжитесь со службой поддержки клиентов.",
  "goodsFreight": "Груз",
  "goodsFreeShipping": "Бесплатно",
  "goodsFreightTips1": "1. Состав трансграничных грузовых перевозок: фрахт = плата за отправку + фрахт на дальние расстояния + плата за доставку.",
  "goodsFreightTips2": "2. Если почтовые условия не выполняются, фрахт взимается в соответствии с фактическими условиями.",
  "goodsFreightTips3": "3. Право на окончательную интерпретацию принадлежит платформе.",
  "pleaseValidPostCode": "Пожалуйста, введите более 4 цифр",
  "pleaseValidEmail": "Пожалуйста, введите правильный адрес электронной почты",
  "pleaseValidPhone": "Пожалуйста, введите правильный номер телефона",
  "productAvailable": "Этот продукт был удален",
  "validatorMaxNumber": "Сумма превышает лимит",
  "validatorRequire": "Обязательные элементы не могут быть нулевыми",
  "validatorPhone": "Пожалуйста, введите правильный номер телефона",
  "validatorEmail": "Пожалуйста, введите правильный формат электронной почты",
  "validatorPassword": "Пароль состоит из 6-12 цифр или букв(содержит специальные символы)",
  "validatorSixNumber": "Пожалуйста, введите 6 чистых цифр",
  "validatorFourMoreNumber": "Пожалуйста, введите комбинацию из 4-32 цифр или букв",
  "validatorIpRule": "Неверный формат IP",
  "validatorChineseAndEnglish": "Только для китайского и английского языков, введите диапазон: 8–64 символа.",
  "collectionSuccess": "Добавить в избранное успешно",
  "followedSuccess": "Подписаться удалось",
  "cancelSuccess": "Отменено успешно",
  "加值": "Добавить",
  "平台人工发起退款": "Платформа искусственно инициирует возврат средств",
  "银行卡": "Банковская карта",
  "提领": "Снять",
  "联系商家": "Связаться с продавцом",
  "evaluateOrder": "Обзор с картинками",
  "evaluateOrderPlaceholder": "Пожалуйста, ознакомьтесь с продуктами",
  "operationSuccess": "Операция прошла успешно",
  "confirmReceiveGoods": "Подтвердить получение товара или нет",
  "evaluateOrderSuccess": "Проверка прошла успешно",
  "yesterday": "Вчера",
  "notLogin": "Вы еще не вошли в систему.",
  "delAllHistoryRecord": "Вы уверены, что хотите удалить всю запись истории?",
  "or": "Или",
  "tipsRemindsText": "Продавец получит напоминание после напоминания об отправке",
  "tipsRemindsCount": "Напомнить можно только один раз.",
  "tipsRemindsMerchant": "Напомнить продавцам",
  "tipsRemindsSuccess": "Напоминание выполнено",
  "noCartTips": "Ваша корзина пуста. Начните делать покупки.",
  "defaultRate": "Система по умолчанию дает положительные отзывы",
  "prevPage": "Предыдущая страница",
  "nextPage": "Следущая страница",
  "returnApply": "Запрос на возврат денег",
  "returnReason": "Причина возврата",
  "returnAmount": "Сумма возврата",
  "returnRemark": "Инструкции по возврату",
  order: {
    confirm: "Подтвердить получение",
    cancel: "Отменить заказ",
    payment: "Заплатить сейчас",
    remind: "Напоминание об отправке",
    return: "Запрос на возврат товара",
    evaluate: "Проверить сейчас",
    logistics: "Посмотреть логистику",
    noRefund: "Невозмещенный",
    refunding: "Выполняется возврат",
    refundSuccess: "Возврат выполнен",
    refundFail: "Не удалось вернуть деньги",
  },
  "remindTitle": "Напоминание об отправке",
  "备注": "Примечание",
  "当前余额": "Текущий баланс",
  "remindContent": "После напоминания об отправке продавец получит напоминание. Напомнить можно только один раз.",
  "remindSuccess": "Напоминание выполнено",
  "remindRepeat": "Об этом приказе напомнили.",
  "noComments": "В настоящее время нет обзора",
  "storeSeach": "Искать товар в этом магазине",
  "storeSeachTips1": "Найдено для вас",
  "storeSeachTips2": "Похожие магазины найдены",
  "storeSeachTips3": "Дом",
  "creditTit": "Кредитные услуги",
  "getCoupons": "Получите больше купонов",
  "yourEmail": "Ваш электронный адрес",
  "subscription": "Подписки",
  "paymethods": "Способ оплаты",
  "footdec": "Пользователи глобального сайта {name} из {num} стран мира используют для расчетов {coin}. {coin} — это безграничная транзакция, которая позволяет совершать немедленные и недорогие транзакции по всему миру без ожидания и международных сборов.",
  "custService": "Обслуживание клиентов",
  "helpLine": "Онлайн обслуживание клиентов",
  "contactUs": "Связаться с нами",
  "partner": "Кооперативные поставщики",
  "buyRules": "Правила покупателя",
  "客户端下载": "Загрузки клиента",
  "提现方式":"Способ вывода средств",
  "sellerRules": "Политика продавца",
  "returnsAndEx": "Возврат и обмен",
  "servicePolicy": "Политика обслуживания",
  "returnPolicy": "Политика возврата",
  "user_Center": "Пользовательский центр",
  "userReg": "Регистрация пользователя",
  "orderTrack": "Запрос заказа",
  "purchageHistory": "История покупки",
  "myPurse": "Мой бумажник",
  "aboutUs": "О нас",
  "Recruitment": "Ждите талантливых людей",
  "news": "Новостная информация",
  "stateMent": "Заявление о современном рабстве",
  "binance": "Бинанс",
  "huobi": "Хуоби",
  "okx": "хорошо",
  "metaMask": "Метамаск",
  "homeBannertips1": "Стать торговцем",
  "homeBannertips2": "Общая комиссия",
  "homeBannertips3": "Макс.",
  "homeBannerbtn": "Присоединяйся сейчас",
  "homeDownloadtips1": "Трансграничный оптовый торговый центр электронной коммерции",
  "homeDownloadtips2": "Специальное предложение бренда",
  "homeDownloadtips3": "Постоянная скидка",
  "homeDownloadtips4": "скачать андроид",
  "homeDownloadtips5": "Apple скачать",
  "homeDownloadtips6": "Отсканируйте QR-код, чтобы загрузить приложение",
  "homeIconTips1": "100% подлинный",
  "homeIconTips2": "возврат 7 дней",
  "homeIconTips3": "Скидка на фрахт",
  "homeIconTips4": "Безопасная оплата",
  "headerSearchTips": "Пожалуйста, введите ключевое слово для поиска",
  "collAccount": "Режим кредита",
  "mine": "Мой.",
  "creditText1": "Стартовые кредиты решают проблему заимствования денег",
  "creditText2": "Предоставление стартового кредита и услуг по обороту капитала",
  "creditWorry": "Кредит без забот",
  "creditQuota": "Гибкий лимит",
  "creditQuotaINFO": "От 100 000 до 30 000 000 с гибким лимитом и без ограничений, с максимальным сроком кредита один год.",
  "quickLoan": "Быстрый кредит",
  "creditReview": "Пройдите аудит не раньше, чем через час, если проверка будет пройдена, кредит будет выдан сразу.",
  "safe": "Безопасно и беззаботно",
  "safeInfo": "Ни ипотеки, ни залога, ни перезвона, ибо это на самом деле личное дело.",
  "about": "О нас",
  "aboutText1": "Мы привержены кредитным финансовым услугам, основанным на философии бизнеса «клиент прежде всего», придерживаемся миссии решения проблемы оборота капитала клиента. За время своего существования компания помогла многочисленным клиентам решить проблему оборота капитала.",
  "aboutText2": "Лимит: 100 000–30 000 000, гибкий метод погашения с низкой процентной ставкой, без первоначального взноса, онлайн-кредит, без телефонного звонка для подтверждения, конфиденциальная информация и кредитование в тот же день.",
  "contactUs1": "Если вы не хотите занимать деньги у своих товарищей по уровню, пожалуйста, свяжитесь с нами.",
  "committed": "Приверженность кредитным услугам для предпринимателей",
  "financial": "Решите свои финансовые проблемы",
  "partnersTit": "Партнер-Платформа онлайн-кредитования",
  "application": "Заявка на получение ссуды",
  "applicant": "Заявитель",
  "actualName": "Настоящее имя",
  "yourName": "Пожалуйста, введите имя",
  "term": "Срок кредита",
  "applicationAmount": "Запрашиваемая сумма",
  "rates": "Процентная ставка по кредиту",
  "loanMethod": "Режим кредита",
  "accountB": "Баланс",
  "countryOf": "Национальность",
  "myloan": "Мой кредит",
  "applyLoan": "Обращаться за ссудой",
  "loaned": "Ссуда",
  "interest": "Начисленные проценты",
  "esRepayment": "Расчетное погашение",
  "loanHistory": "Кредитная запись",
  "applicantDate": "Дата подачи документов",
  "repayment": "погашение",
  "cycle": "Цикл погашения",
  "fixedRate": "Фиксированная процентная ставка",
  "successLoan": "Кредит успешно",
  "Reapply": "Подать заявку повторно",
  "borrow": "Ссуда не удалась",
  "applicantIn": "Выполняется заявка",
  "repaid": "погашение",
  "overdue": "Просрочено",
  "estirepay": "Расчетное погашение",
  "loanDays": "Количество дней кредита",
  "reAmount": "Сумма погашения",
  "repay": "Режим погашения",
  "entRepay": "Подтвердить погашение",
  "foryourmoney": "Если вам не хватает средств, вам негде взять деньги в долг или вы стесняетесь брать деньги взаймы у своих друзей, вы можете связаться с нами. У нас есть весь процесс профессионального обслуживания, чтобы ответить на ваши сомнения в любое время. Наша цель — сделать каждый кредит прозрачным, чтобы клиенты могли его использовать быстро и уверенно.",
  "onlineApplin": "Подать заявку онлайн",
  "businessloan": "Заявка на стартовый кредит",
  "selectCountry": "Пожалуйста, выберите национальность",
  "selectPeriod": "Выберите период",
  "passPortImg": "№ удостоверения личности/номер паспорта",
  "uploadId": "Загрузка фото сертификата/паспорта",
  "readAndAgree": "Я прочитал и согласен",
  "loanAgree": "Договор о кредите",
  "submitApplica": "Подача заявки",
  "photoExample": "Пример съемки",
  "discounted": "Товары со скидкой",
  "days": "день",
  "privacyPolicy": "Политика конфиденциальности",
  "delivery": "Доставка и самовывоз",
  "checkAgreement": "Пожалуйста, отметьте соглашение!",
  "businessPhone": "Рабочий телефон",
  "businessEmail": "Корпоративная электронная почта",

  "提交失败": "Отправить не удалось",
  "充值金额不能小于1": "Сумма пополнения не может быть меньше 1 (включая два знака после запятой)",
  "请切换其他语言后查看": "Пожалуйста, переключитесь на другой язык для просмотра",
  "我的购物车": "Моя корзина",
  "推荐商品": "Рекомендуемые продукты",
  "猜你喜欢": "Думаю, вам это нравится.",
  "暂无店铺": "Магазин не найден",
  "添加失败": "Не удалось отправить. Пожалуйста, повторите попытку позже",
  "提交订单": "Подача заказа",
  recommendclass: "Рекомендуемые категории",
  "滑动验证": "Проверка на скользящую панель",
  "最多上传9张图片": "Максимум 9 изображений",
  "账号注销": "Отмена учетной записи",
  "确定注销": "Подтвердить отмену",
  "您的账号": "Ваша учетная запись",
  "为什么要离开": "Почему вы уходите?",
  "App下载(买家端)": "Загрузка приложения (покупатель)",
  "App下载(卖家端)": "Загрузка приложения (продавец)",
  "您还有余额,不能注销账号": "У вас есть остаток, вы не можете отменить учетную запись!",
  "请输入注销理由": "Пожалуйста, введите причину отмены",
  "您确认要注销吗?": "Вы уверены, что хотите отменить?",
  "我再考虑下": "Я еще подумаю",
  "同意注销": "Согласиться с отменой",
  "注销成功": "Отмена успешна",
  "最多包含10位小数": "Максимум 10 десятичных знаков",
  "企业电话": "Контактный телефон",
  "加密货币": "Криптовалюта",
  "职业机会": "Карьерная перспектива",
  "银行卡": "Банковская карта",
  "充值币种": "Валюта пополнения",
  "充值金额": "Сумма пополнения",
  '参数缺失': "Отсутствует параметр",
  '充值数量必填': "Количество пополнения обязательно",
  "充值金额不得小于": "Сумма пополнения не может быть меньше",
  "长时间未付款，系统自动取消订单": "Долгое время не оплачивается, система автоматически отменяет заказ",
  "充值金额不得大于": "Сумма пополнения не может быть больше",
  "请先选择币种": "Пожалуйста, выберите валюту",
  "开户行": "Банк",
  "请输入开户行名称": "Пожалуйста, введите название банка",
  "银行卡号": "Номер банковской карты",
  "点击去支付": "Нажмите, чтобы оплатить",
  "企业证明": "Корпоративное подтверждение",
  "请输入银行卡号": "Пожалуйста, введите номер банковской карты",
  footTipTikTok:'Торговый центр CoveBuy ©️2024 Copyright',
  TikTokFoot:'CoveBuy — это глобальная социальная платформа для коротких видеороликов CoveBuy и крупнейшая в Азии оптовая торговая компания Alibaba, созданная в сотрудничестве. Это глобальная платформа электронной коммерции, которая имеет три самоуправляемых интеллектуальных склада в мире, расположенных в Торонто, Канада, Лос-Анджелесе и Тибе, Япония. В приложении продаются популярные товары из Японии, Южной Кореи, Китая и других азиатских стран. В настоящее время их общее число превысило 50 000 и продолжает быстро расти.',
  "cancelInfo":"предупреждать! Пожалуйста, будьте осторожны при удалении учетной записи. Если вы больше не используете учетную запись, вы можете нажать [Согласен на отмену]. Возможно, вы не сможете зарегистрироваться в течение нескольких дней после отмены.",
  "betaBannerText": "Сайт находится в открытом тестировании, пожалуйста, не делайте заказы"
}